const replaceFieldValues = (obj, value, newValue) => {
    const updatedObj = {};
    const regex = new RegExp(value, 'g');

    for (const key in obj) {
        if (typeof obj[key] === 'string') {
            updatedObj[key] = obj[key]?.replace(regex, newValue);
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            updatedObj[key] = replaceFieldValues(obj[key], value, newValue);
        } else {
            updatedObj[key] = obj[key];
        }
    }

    return updatedObj;
};

export const handledCurrencyFields = (langFields, currency = 'MDL', locale = 'ro') => {
    let newLangObject = langFields;
    currency = (currency || '').toUpperCase();

    const currencies = {
        MDL: { ro: 'lei', ru: 'лей', en: 'lei', uk: 'леї' },
        RON: { ro: 'ron', ru: 'рон', en: 'ron', uk: 'рон' },
        USD: { ro: '$', ru: '$', en: '$', uk: '$' },
        EUR: { ro: 'eur', ru: 'eur', en: 'eur', uk: 'eur' },
        UAH: { ro: '₴', ru: '₴', en: '₴', uk: '₴' },
    };

    if (!currencies[currency]) {
        console.warn(`Unsupported currency "${currency}"`);
        return newLangObject; // Возврат без изменений
    }

    const newCurrencyValue = currencies[currency][locale];
    if (!newCurrencyValue) {
        console.warn(`Unsupported locale "${locale}" for currency "${currency}"`);
        return newLangObject; // Возврат без изменений
    }

    if (currencies[currency]) {
        newLangObject = replaceFieldValues(newLangObject, 'MDL', newCurrencyValue.toUpperCase());
        newLangObject = replaceFieldValues(newLangObject, 'mdl', newCurrencyValue);
        newLangObject = replaceFieldValues(newLangObject, 'lei', newCurrencyValue);
        newLangObject = replaceFieldValues(newLangObject, 'лей', newCurrencyValue);
        newLangObject = replaceFieldValues(newLangObject, 'леї', newCurrencyValue);
    }

    return newLangObject;
};
